import * as React from "react";
import {
    Grid,
    Paper,
    IconButton,
    Typography,
    Tooltip
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { inject, observer } from "mobx-react";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import createStyles from "@material-ui/core/styles/createStyles";
import Label from "./Label"
import DeleteIcon from "@material-ui/icons/Delete";
import BrushIcon from "@material-ui/icons/Brush";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import { lighten, darken } from "@material-ui/core/styles/colorManipulator";
import LabelerSegmentationUiStore from "../../../store/segmentation-store/labelerSegmentationUiStore";
import LabelerSegmentationStore from "../../../store/segmentation-store/labelerSegmentationStore";

const styles = (theme: Theme) =>
  createStyles({
    root: {
        padding: "0 16px",
    }
  });

const Labels = ({ labelerSegmentationUiStore, labelerSegmentationStore, classes }: any) => {

    const {
        polygons
    } = labelerSegmentationUiStore as LabelerSegmentationUiStore

    const {
        buildTags,
        tags
    } = labelerSegmentationStore as LabelerSegmentationStore

    React.useEffect(() => {
        buildTags()
    }, [polygons])

    return (
        <Grid container spacing={8} className={classes.root}>
            {tags.map((tag: any, index: number) => {
                return (
                    <Grid item xs={6}>
                        <Label 
                            key={index}
                            index={index}
                            label={tag}
                        />    
                    </Grid>
                )
            })}
        </Grid>
    )
}
export default withStyles(styles)(
    inject("labelerSegmentationUiStore", "labelerSegmentationStore")(observer(Labels))
);